import { createAction } from 'redux-actions';
export var UPDATE_WINDOW_SIZE = 'CLIENT.WINDOW_SIZE.UPDATE';
export var updateWindowSize = createAction(UPDATE_WINDOW_SIZE);
